import { useEffect, useState } from "react";

interface StepItem {
    id: number;
    title: string;
    subtitle: string;
}
type StepStatus = 'complete' | 'active' | 'upcoming';
const EventSidebarMenu = ({ currentStep, setCurrentStep, setEditEventClicked, setIsFinalStep, isFinalStep }: any) => {
    const steps: StepItem[] = [
        { id: 1, title: 'Event Setup', subtitle: 'Live Stream / Video' },
        { id: 2, title: 'Select or Create Content', subtitle: 'Live Webinar - The Latest AI Strategie...' },
        { id: 3, title: 'Event Details', subtitle: 'Date, time, description and settings' },
        { id: 4, title: 'Registration Setup', subtitle: 'Form fields, access and options' },
        { id: 5, title: 'Images & Style', subtitle: 'Event page content' },
        { id: 6, title: 'Email & Notifications', subtitle: 'Confirmation and reminders' },
        { id: 7, title: 'Review & Complete', subtitle: 'Check settings and activate' }
    ];
    const getStatus = (stepId: number): StepStatus => {
        if (stepId < currentStep) return 'complete';
        if (stepId === currentStep) return 'active';
        return 'upcoming';
    };
    const [mobileOpen, setMobileOpen] = useState(false);
    const activeStep = steps.find(s => s.id === currentStep) ?? steps[0];
    const handleSideMenuClick = (step: any) => {
        if (isFinalStep) {
            setCurrentStep(step.id)
        }
        setEditEventClicked(true)
        setMobileOpen(false)
    }

    return (
        <aside className="w-full md:w-72 md:flex-shrink-0">
            <div className="mb-1">
                <h1 className="text-lg md:text-xl font-semibold text-gray-900 m-0">Create Event</h1>
                <p className="hidden md:block text-sm text-gray-400 mt-1">
                    Set up a new event and configure registration, content and settings.
                </p>
            </div>

            {/* Mobile: compact stepper */}
            <button
                type="button"
                onClick={() => setMobileOpen(o => !o)}
                className="md:hidden w-full mt-3 flex items-center justify-between gap-3 bg-white border border-gray-200 rounded-xl px-4 py-3 text-left">
                <div className="min-w-0">
                    <p className="m-0 text-xs text-gray-400">Step {currentStep} of {steps.length}</p>
                    <p className="m-0 text-sm font-semibold text-indigo-600 truncate">{activeStep.title}</p>
                </div>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
                    className={`flex-shrink-0 text-gray-500 transition-transform ${mobileOpen ? 'rotate-180' : ''}`}>
                    <polyline points="6 9 12 15 18 9" />
                </svg>
            </button>
            <div className="md:hidden h-1 bg-gray-200 rounded-full mt-2 overflow-hidden">
                <div className="h-full bg-indigo-600 transition-all" style={{ width: `${(currentStep / steps.length) * 100}%` }} />
            </div>

            {/* Step list: collapsible on mobile, always visible on md+ */}
            <ul className={`${mobileOpen ? 'block' : 'hidden'} md:block p-0 m-0 mt-2 md:mt-0 list-none bg-white md:bg-transparent border md:border-0 border-gray-200 rounded-xl p-2 md:p-0`}>
                {steps.map((step, index) => {
                    const status = getStatus(step.id);
                    const isLast = index === steps.length - 1;
                    return (
                        <li key={step.id} className="relative cursor-pointer" onClick={() => handleSideMenuClick(step)}>
                            <div className={`flex items-start gap-3 px-2 py-2.5 rounded-lg ${status === 'active' ? 'bg-indigo-50' : ''}`}>
                                <div className="flex flex-col items-center">
                                    <span
                                        className={`flex items-center justify-center w-9 h-9 rounded-full text-sm font-semibold flex-shrink-0 ${status === 'complete'
                                            ? 'bg-indigo-100 text-indigo-600'
                                            : status === 'active'
                                                ? 'bg-indigo-600 text-white ring-4 ring-indigo-100'
                                                : 'bg-gray-100 text-gray-400'
                                            }`}>
                                        {status === 'complete' ? (
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                                                <polyline points="20 6 9 17 4 12" />
                                            </svg>
                                        ) : (
                                            step.id
                                        )}
                                    </span>
                                    {!isLast && (
                                        <span className={`w-px flex-1 min-h-[22px] my-1 ${status === 'complete' ? 'bg-indigo-200' : 'bg-gray-200'}`} />
                                    )}
                                </div>
                                <div className="leading-tight pt-1.5 pb-3 min-w-0">
                                    <p className={`m-0 text-sm font-semibold ${status === 'active' ? 'text-indigo-600' : 'text-gray-800'}`}>
                                        {step.title}
                                    </p>
                                    <p className="m-0 text-xs text-gray-400 mt-0.5 truncate">{step.subtitle}</p>
                                </div>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </aside>

    )
}

export default EventSidebarMenu